<div
	class="freya-event-container"
	[class.freya-event-hidden]="isHidden"
>
	<div class="freya-calendar-event">
		<div class="title">{{event.title}}</div>
		<div class="reason">{{event.description}}</div>
	</div>
</div>